import React from 'react';
import { VehicleInspectionType } from '@appTypes/vehicleInspectionType';
import { VehicleAlerts } from '../VehicleAlerts/VehicleAlerts';
import { createDate, VehicleInspectionContextKey } from '../VehicleInspection.utils';
import * as S from './LookupResult.styles';

interface LookupResultProps {
  vehicleInspection: VehicleInspectionType;
  selectedContextKey?: VehicleInspectionContextKey;
}

export const LookupResult = ({ vehicleInspection, selectedContextKey }: LookupResultProps) => {
  const { manufactureName, modelName, year, nextInspectionDate, callToAction } = vehicleInspection;

  return (
    <S.ResultWrapper>
      <S.VehicleData>
        {manufactureName} {modelName}, {year}
      </S.VehicleData>
      <S.DateRow>
        <S.DueText>Neste frist for godkjent EU-kontroll:</S.DueText>
        <S.DateText>{createDate(nextInspectionDate)}</S.DateText>
      </S.DateRow>
      <VehicleAlerts callToAction={callToAction} selectedContextKey={selectedContextKey} />
    </S.ResultWrapper>
  );
};
